import { useSupabaseTokens } from './useSupabaseTokens';

export const useTokens = (externalSearchQuery?: string, categoryFilter?: string) => {
  // Use Supabase hook for token data
  const supabaseTokens = useSupabaseTokens(externalSearchQuery, categoryFilter);
  
  // Return the same interface for backward compatibility plus pagination
  return {
    tokens: supabaseTokens.tokens,
    allTokens: supabaseTokens.allTokens,
    loading: supabaseTokens.loading,
    error: supabaseTokens.error,
    searchQuery: supabaseTokens.searchQuery,
    setSearchQuery: supabaseTokens.setSearchQuery,
    refetch: supabaseTokens.refetch,
    // Pagination properties
    currentPage: supabaseTokens.currentPage,
    totalPages: supabaseTokens.totalPages,
    totalTokens: supabaseTokens.totalTokens,
    goToPage: supabaseTokens.goToPage,
    goToNextPage: supabaseTokens.goToNextPage,
    goToPreviousPage: supabaseTokens.goToPreviousPage,
  };
}; 